import { render, staticRenderFns } from "./SignAby.vue?vue&type=template&id=063995d6&scoped=true&"
import script from "./SignAby.vue?vue&type=script&lang=js&"
export * from "./SignAby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063995d6",
  null
  
)

export default component.exports